import Stack from '../../_components/Stack';
import type { EmptyStateProps } from './types';
import EmptyStateWithList from './variants/EmptyStateWithList';
import EmptyStateDefault from './variants/EmptyStateDefault';
import EmptyStateAsStep from './variants/EmptyStateAsStep';
import EmptyStateStatus from './variants/EmptyStateStatus';

const EmptyStateMap: Record<string, React.FC<EmptyStateProps>> = {
  default: EmptyStateDefault,
  list: EmptyStateWithList,
  step: EmptyStateAsStep,
  status: EmptyStateStatus,
};

function EmptyState(props: EmptyStateProps) {
  const { variant, className } = props;
  const EmptyStateComponent = EmptyStateMap[variant];

  return (
    <Stack className={className} direction="row" justifyContent="center">
      <EmptyStateComponent {...props} />
    </Stack>
  );
}

export default EmptyState;
